/**
 * @fileoverview POST handler for the "/apps/:app_group_id/territory_create" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdTerritoryCreateCacheKeys } from "./constants";
import type { PostAppsAppGroupIdTerritoryCreateProps, TeamCreateResult } from "./types";

export const postTeamCreate = reactQueryMutationAdapter(
  appsAppGroupIdTerritoryCreateCacheKeys,
  (props: PostAppsAppGroupIdTerritoryCreateProps): Promise<TeamCreateResult> => {
    // manipulate props here as needed { filters, id, name }

    return fetch(`/apps/${props.appGroupId}/territory_create`, "POST", props);
  }
);
